import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Field, ErrorMessage } from 'formik';
import { Navbar2 } from '../support/Navbar2';
import { Redirect } from 'react-router-dom';
import { startCargandoClientes, startCreandoCliente, startEliminarCliente, startActualizandoCliente } from '../../redux/store/pedidos/thunks';
import { ClienteModal } from '../support/ClienteModal';
import Swal from 'sweetalert2';
import { FirebaseDB } from '../../firebase/config';

const municipiosColima = [
    "Armería", "Colima", "Comala", "Coquimatlán", "Cuauhtémoc",
    "Ixtlahuacán", "Manzanillo", "Minatitlán", "Tecomán", "Villa de Álvarez"
];

const tiposUsuario = ["VIP", "Moderado", "Bajo"];

export const ClientesScreen = () => {
    const dispatch = useDispatch();
    const { clientes } = useSelector(state => state.pedidos);
    const { perfil } = useSelector(state => state.auth);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedCliente, setSelectedCliente] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [currentClienteId, setCurrentClienteId] = useState(null);
    const [municipios, setMunicipios] = useState(() => {
        const saved = localStorage.getItem('municipiosColima');
        return saved ? JSON.parse(saved) : municipiosColima;
    });
    const [formValues, setFormValues] = useState({
        nombre: '',
        nombreComercial: '',
        direccion: '',
        codigoPostal: '',
        municipio: 'Colima',
        tipoUsuario: 'Moderado',
        rfc: '',
        direccionFactura: '',
        telefono: '',
        email: '',
        fechaUltimoPedido: '',
        noFactura: '',
        frecuenciaPedidos: '',
        giroCliente: '',
        esSucursal: 'No',
        usuarioUID: ''
    });

    // Cargar todos los usuarios con perfil 'Cliente' para la vinculación manual (Admin only)
    const [usuariosClientes, setUsuariosClientes] = useState([]);
    
    useEffect(() => {
        if (perfil === 'Administrador') {
            const fetchUsuariosClientes = async () => {
                try {
                    const { collection, getDocs, query, where } = await import('firebase/firestore/lite');
                    const ref = collection(FirebaseDB, 'usuarios');
                    const q = query(ref, where('perfil', '==', 'Cliente'));
                    const snap = await getDocs(q);
                    const list = [];
                    snap.forEach(doc => {
                        list.push({ docID: doc.id, ...doc.data() });
                    });
                    setUsuariosClientes(list);
                } catch (e) {
                    console.error('Error al cargar usuarios-Cliente:', e);
                }
            };
            fetchUsuariosClientes();
        }
    }, [perfil]);

    const handleDetalles = (cliente) => {
        setSelectedCliente(cliente);
        setModalOpen(true);
    };

    const handleEdit = (cliente) => {
        setIsEditing(true);
        setCurrentClienteId(cliente.id);
        setFormValues({
            nombre: cliente.nombre || '',
            nombreComercial: cliente.nombreComercial || '',
            direccion: cliente.direccion || '',
            codigoPostal: cliente.codigoPostal || '',
            municipio: cliente.municipio || 'Colima',
            tipoUsuario: cliente.tipoUsuario || 'Moderado',
            rfc: cliente.rfc || '',
            direccionFactura: cliente.direccionFactura || '',
            telefono: cliente.telefono || '',
            email: cliente.email || '',
            fechaUltimoPedido: cliente.fechaUltimoPedido || '',
            noFactura: cliente.noFactura || '',
            frecuenciaPedidos: cliente.frecuenciaPedidos || '',
            giroCliente: cliente.giroCliente || '',
            esSucursal: cliente.esSucursal || 'No',
            usuarioUID: cliente.usuarioUID || ''
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleDelete = (id) => {
        dispatch(startEliminarCliente(id));
    };

    const handleCancelEdit = () => {
        setIsEditing(false);
        setCurrentClienteId(null);
        setFormValues({
            nombre: '',
            nombreComercial: '',
            direccion: '',
            codigoPostal: '',
            municipio: 'Colima',
            tipoUsuario: 'Moderado',
            rfc: '',
            direccionFactura: '',
            telefono: '',
            email: '',
            fechaUltimoPedido: '',
            noFactura: '',
            frecuenciaPedidos: '',
            giroCliente: '',
            esSucursal: 'No',
            usuarioUID: ''
        });
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const itemsPerPage = 20;

    useEffect(() => {
        const unsubscribe = dispatch(startCargandoClientes(null));
        return () => {
             if (typeof unsubscribe === 'function') unsubscribe();
        }
    }, [dispatch]);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    const perfilesPermitidos = ["Administrador", "Seguimiento", "Sucursal", "Vendedor", "Empleado"];
    if (!perfilesPermitidos.includes(perfil)) {
        return <Redirect to="/" />;
    }

    const filteredClientes = (clientes || []).filter(cliente => {
        const term = searchTerm.toLowerCase().trim();
        if (!term) return true;
        const nombre = (cliente.nombre || '').toLowerCase();
        const nombreComercial = (cliente.nombreComercial || '').toLowerCase();
        return nombre.includes(term) || nombreComercial.includes(term);
    });

    const totalPages = Math.ceil((filteredClientes?.length || 0) / itemsPerPage) || 1;
    const activePage = currentPage > totalPages ? totalPages : currentPage;
    const startIndex = (activePage - 1) * itemsPerPage;
    const currentClientes = filteredClientes.slice(startIndex, startIndex + itemsPerPage);

    return (
        <div>
            <Navbar2 />
            <h1 className='settings__title'>Administración de Clientes</h1>

            <div className='generate__container' style={{ marginTop: '20px' }}>
                <Formik
                    enableReinitialize={true}
                    initialValues={formValues}
                    validate={(valores) => {
                        let errores = {};
                        if (!valores.nombre) {
                            errores.nombre = 'El nombre del cliente es requerido';
                        }
                        if (!valores.direccion) {
                            errores.direccion = "La dirección de entrega es requerida";
                        }
                        if (!valores.telefono) {
                            errores.telefono = 'El teléfono es requerido';
                        }
                        return errores;
                    }}
                    onSubmit={(valores, { resetForm }) => {
                        // Check for duplicate Nombre Comercial (case-insensitive), ignoring the current client when editing
                        const nombreComercialExists = valores.nombreComercial && clientes.some(c =>
                          (isEditing ? c.id !== currentClienteId : true) &&
                          c.nombreComercial &&
                          c.nombreComercial.trim().toLowerCase() === valores.nombreComercial.trim().toLowerCase()
                        );
                        // Check for duplicate RFC (case-insensitive) - only if not a branch (sucursal), and ignoring current client when editing
                        const isSucursal = valores.esSucursal === 'Sí';
                        const rfcExists = !isSucursal && valores.rfc && clientes.some(c =>
                          (isEditing ? c.id !== currentClienteId : true) &&
                          c.rfc &&
                          c.rfc.toLowerCase() === valores.rfc?.toLowerCase()
                        );

                        if (nombreComercialExists || rfcExists) {
                            Swal.fire({
                                icon: 'error',
                                title: 'Cliente existente',
                                text: nombreComercialExists && rfcExists 
                                    ? 'Ya existe un cliente con ese Nombre Comercial y RFC' 
                                    : nombreComercialExists 
                                        ? 'Ya existe un cliente con ese Nombre Comercial' 
                                        : 'Ya existe un cliente con ese RFC',
                                toast: true,
                                position: 'top-end',
                                timer: 3000,
                                showConfirmButton: false,
                            });
                            return;
                        }
                        if (isEditing) {
                            dispatch(startActualizandoCliente(currentClienteId, valores));
                            handleCancelEdit();
                        } else {
                            dispatch(startCreandoCliente(valores));
                        }
                        resetForm();
                    }}
                >
                    {({ handleSubmit, setFieldValue }) => (
                        <form className='generate__form' onSubmit={handleSubmit}>
                            <div className='generate__form-section'>
                                <p className='generate__sectionName'>{isEditing ? 'Editar Cliente' : 'Alta de Cliente'}</p>

                                <div className="generate__row">
                                    <div className="col-40">
                                        <label className='generate__label'>
                                            Cliente:
                                            <Field type="text" name="nombre" placeholder="Nombre completo o Razón Social" className='generate__input' />
                                        </label>
                                        <ErrorMessage name="nombre" component={() => (<div className="generate__error">{'Requerido'}</div>)} />
                                    </div>
                                    <div className="col-40">
                                        <label className='generate__label'>
                                            Nombre Comercial:
                                            <Field type="text" name="nombreComercial" placeholder="Nombre comercial o informal (Opcional)" className='generate__input' />
                                        </label>
                                    </div>
                                    <div className="col-20">
                                        <label className='generate__label'>
                                            Tipo de Usuario:
                                            <Field as="select" name="tipoUsuario" className='generate__input'>
                                                {tiposUsuario.map(tipo => (
                                                    <option key={tipo} value={tipo}>{tipo}</option>
                                                ))}
                                            </Field>
                                        </label>
                                    </div>
                                </div>

                                <div className="generate__row">
                                    <div className="col-50">
                                            <label className='generate__label'>
                                            Dirección de Entrega:
                                            <Field type="text" name="direccion" placeholder="Dirección de Entrega completa" className='generate__input'  />
                                        </label>
                                        <ErrorMessage name="direccion" component={() => (<div className="generate__error">{'Requerido'}</div>)} />
                                    </div>
                                    <div className="col-25">
                                        <label className='generate__label'>
                                            Código Postal:
                                            <Field type="text" name="codigoPostal" placeholder="Código Postal" className='generate__input' />
                                        </label>
                                    </div>
                                    <div className="col-25">
                                        <label className='generate__label'>
                                            Municipio:
                                            <Field 
                                                as="select" 
                                                name="municipio" 
                                                className='generate__input'
                                                onChange={(e) => {
                                                    const val = e.target.value;
                                                    if (val === "AGREGAR_NUEVO") {
                                                        const nuevo = window.prompt("Ingrese el nombre del nuevo municipio:");
                                                        if (nuevo && nuevo.trim()) {
                                                            const nuevoTrimmed = nuevo.trim();
                                                            if (!municipios.includes(nuevoTrimmed)) {
                                                                const nuevasOpciones = [...municipios, nuevoTrimmed].sort();
                                                                setMunicipios(nuevasOpciones);
                                                                localStorage.setItem('municipiosColima', JSON.stringify(nuevasOpciones));
                                                            }
                                                            setFieldValue("municipio", nuevoTrimmed);
                                                        }
                                                    } else {
                                                        setFieldValue("municipio", val);
                                                    }
                                                }}
                                            >
                                                {municipios.map(mun => (
                                                    <option key={mun} value={mun}>{mun}</option>
                                                ))}
                                                <option value="AGREGAR_NUEVO" style={{ color: '#3b82f6', fontWeight: 'bold' }}>+ Agregar municipio...</option>
                                            </Field>
                                        </label>
                                    </div>
                                </div>

                                <div className="generate__row">
                                    <div className="col-40">
                                        <label className='generate__label'>
                                            Fecha del Último Pedido:
                                            <Field type="date" name="fechaUltimoPedido" className='generate__input' />
                                        </label>
                                    </div>
                                    <div className="col-30">
                                        <label className='generate__label'>
                                            No. de Factura:
                                            <Field type="text" name="noFactura" placeholder="No. de Factura (Opcional)" className='generate__input' />
                                        </label>
                                    </div>
                                    <div className="col-30">
                                        <label className='generate__label'>
                                            Frecuencia de Pedidos:
                                            <Field as="select" name="frecuenciaPedidos" className='generate__input'>
                                                <option value=''>Frecuencia (Opcional)</option>
                                                <option value='7 días'>7 días</option>
                                                <option value='14 días'>14 días</option>
                                                <option value='30 días'>30 días</option>
                                                <option value='60 días'>60 días</option>
                                            </Field>
                                        </label>
                                    </div>
                                </div>

                                <div className="generate__row">
                                    <div className="col-50">
                                        <label className='generate__label'>
                                            Dirección de Facturación:
                                            <Field type="text" name="direccionFactura" placeholder="Dirección de Facturación (Opcional)" className='generate__input' />
                                        </label>
                                    </div>
                                    <div className="col-30">
                                        <label className='generate__label'>
                                            RFC:
                                            <Field type="text" name="rfc" placeholder="RFC (Opcional)" className='generate__input' />
                                        </label>
                                    </div>
                                    <div className="col-20">
                                        <label className='generate__label'>
                                            Sucursal:
                                            <Field as="select" name="esSucursal" className='generate__input'>
                                                <option value="No">No</option>
                                                <option value="Sí">Sí</option>
                                            </Field>
                                        </label>
                                    </div>
                                </div>

                                <div className="generate__row">
                                    <div className="col-35">
                                        <label className='generate__label'>
                                            Giro del Cliente:
                                            <Field as="select" name="giroCliente" className='generate__input'>
                                                <option value="">Seleccionar giro (Opcional)</option>
                                                <option value="Comercial">Comercial</option>
                                                <option value="Servicios Gubernamentales">Servicios Gubernamentales</option>
                                                <option value="Manufactura/industrial">Manufactura/industrial</option>                                                <option value="Servicios">Servicios</option>
                                                <option value="Turístico">Turístico</option>
                                                <option value="Restaurantero o alimenticio">Restaurantero o alimenticio</option>
                                                <option value="Construcción">Construcción</option>
                                                <option value="Educativo">Educativo</option>
                                                <option value="Logístico o transporte">Logístico o transporte</option>
                                                <option value="Salud">Salud</option>
                                                <option value="Agropecuario">Agropecuario</option>
                                                <option value="Tecnológico">Tecnológico</option>
                                                <option value="Otros">Otros</option>
                                            </Field>
                                        </label>
                                    </div>
                                    <div className="col-30">
                                        <label className='generate__label'>
                                            Teléfono:
                                            <Field type="text" name="telefono" placeholder="Teléfono iniciando con 52" className='generate__input'  />
                                        </label>
                                        <ErrorMessage name="telefono" component={() => (<div className="generate__error">{'Requerido'}</div>)} />
                                    </div>
                                    <div className="col-35">
                                        <label className='generate__label'>
                                            Correo Electrónico:
                                            <Field type="email" name="email" placeholder="Correo electrónico (Opcional)" className='generate__input' />
                                        </label>
                                    </div>
                                </div>

                                {perfil === 'Administrador' && (
                                    <div className="generate__row">
                                        <div className="col-100">
                                            <label className='generate__label'>
                                                Cuenta de Usuario Vinculada (Acceso para levantar pedidos propios):
                                                <Field as="select" name="usuarioUID" className='generate__input'>
                                                    <option value="">-- Sin Vincular / Sin Acceso Propio --</option>
                                                    {usuariosClientes.map(u => {
                                                        // Mostrar si no está vinculado a otro cliente, o si es el usuarioUID actualmente asignado
                                                        const estaVinculado = clientes.some(c => c.usuarioUID === u.uid && c.id !== currentClienteId);
                                                        if (estaVinculado) return null;
                                                        return (
                                                            <option key={u.uid} value={u.uid}>
                                                                {u.displayName || u.email} ({u.email})
                                                            </option>
                                                        );
                                                    })}
                                                </Field>
                                            </label>
                                        </div>
                                    </div>
                                )}


                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button type="submit" className='generate__btn generate__btn-primary'>
                                    {isEditing ? 'Actualizar Cliente' : 'Guardar Cliente'}
                                </button>
                                {isEditing && (
                                    <button 
                                        type="button" 
                                        className='generate__btn' 
                                        onClick={handleCancelEdit}
                                        style={{ background: '#6b7280' }}
                                    >
                                        Cancelar
                                    </button>
                                )}
                            </div>
                        </form>
                    )}
                </Formik>
            </div>

            <h1 className='settings__title' style={{ marginTop: '40px' }}>Directorio de Clientes</h1>
            
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                <div style={{ position: 'relative', width: '80%', display: 'flex', gap: '10px' }}>
                    <input
                        type="text"
                        placeholder="Buscar por nombre del cliente o nombre comercial..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            width: '100%',
                            padding: '10px 15px',
                            borderRadius: '6px',
                            border: '1px solid #d1d5db',
                            fontSize: '14px',
                            outline: 'none',
                            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                        }}
                    />
                    {searchTerm && (
                        <button
                            type="button"
                            onClick={() => setSearchTerm('')}
                            style={{
                                padding: '0 15px',
                                background: '#ef4444',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontWeight: '600',
                            }}
                        >
                            Limpiar
                        </button>
                    )}
                </div>
            </div>

            <div className='dashboard__pedidos'>
                {clientes && clientes.length > 0 ? (
                    filteredClientes.length > 0 ? (
                        <table className="table table-striped table-hover mt-3" style={{ width: '80%', margin: '0 auto', backgroundColor: 'white' }}>
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Dirección de Entrega</th>
                                    <th>Municipio</th>
                                    <th>Giro del Cliente</th>
                                    <th>Tipo</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentClientes.map(cliente => (
                                    <tr key={cliente.id}>
                                        <td>
                                            {cliente.nombre}
                                            {cliente.usuarioUID && (
                                                <span 
                                                    style={{ marginLeft: '8px', padding: '2px 6px', background: '#dcfce7', color: '#16a34a', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold' }} 
                                                    title="Cuenta de acceso vinculada"
                                                >
                                                    👤 Vinculado
                                                </span>
                                            )}
                                        </td>
                                        <td>{cliente.direccion}</td>
                                        <td>{cliente.municipio}</td>
                                        <td>{cliente.giroCliente}</td>
                                        <td>{cliente.tipoUsuario}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                            <div style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
                                                <button
                                                    type="button"
                                                    onClick={() => handleDetalles(cliente)}
                                                    style={{ cursor: 'pointer', padding: '5px 8px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '4px', fontSize: '13px' }}
                                                    title="Detalles"
                                                >
                                                    <i className="fas fa-eye"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => handleEdit(cliente)}
                                                    style={{ cursor: 'pointer', padding: '5px 8px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '4px', fontSize: '13px' }}
                                                    title="Modificar"
                                                >
                                                    <i className="fas fa-edit"></i>
                                                </button>
                                                {perfil === "Administrador" && (
                                                    <button
                                                        type="button"
                                                        onClick={() => handleDelete(cliente.id)}
                                                        style={{ cursor: 'pointer', padding: '5px 8px', background: '#ef4444', color: 'white', border: 'none', borderRadius: '4px', fontSize: '13px' }}
                                                        title="Eliminar"
                                                    >
                                                        <i className="fas fa-trash"></i>
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <p>No se encontraron clientes que coincidan con la búsqueda.</p>
                        </div>
                    )
                ) : (
                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <p>No hay clientes registrados.</p>
                    </div>
                )}
            </div>

            {filteredClientes && filteredClientes.length > 0 && (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', marginTop: '20px' }}>
                    <button
                        disabled={activePage === 1}
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        style={{
                            padding: '8px 16px',
                            background: activePage === 1 ? '#e5e7eb' : '#3b82f6',
                            color: activePage === 1 ? '#9ca3af' : 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: activePage === 1 ? 'not-allowed' : 'pointer',
                            fontWeight: '600',
                            transition: 'background-color 0.2s',
                            boxShadow: activePage === 1 ? 'none' : '0 2px 4px rgba(59, 130, 246, 0.2)'
                        }}
                    >
                        Anterior
                    </button>
                    <span style={{ fontSize: '15px', fontWeight: '600', color: '#374151' }}>
                        Página {activePage} de {totalPages}
                    </span>
                    <button
                        disabled={activePage === totalPages}
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        style={{
                            padding: '8px 16px',
                            background: activePage === totalPages ? '#e5e7eb' : '#3b82f6',
                            color: activePage === totalPages ? '#9ca3af' : 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: activePage === totalPages ? 'not-allowed' : 'pointer',
                            fontWeight: '600',
                            transition: 'background-color 0.2s',
                            boxShadow: activePage === totalPages ? 'none' : '0 2px 4px rgba(59, 130, 246, 0.2)'
                        }}
                    >
                        Siguiente
                    </button>
                </div>
            )}
            
            <br />

            {modalOpen && selectedCliente && (
                <ClienteModal closeModal={setModalOpen} cliente={selectedCliente} />
            )}
        </div>
    );
};
